import theme from 'src/theme';

export const toolCallSx = {
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 2.5,
        ml: 6,
        px: 2,
        py: 1.25,
        bgcolor: theme.palette.common.white,
        borderRadius: '12px',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.03)',
        width: 'fit-content',
        animation: 'slideUp 0.25s ease-out',
        '@keyframes slideUp': {
            from: {opacity: 0, transform: 'translateY(6px)'},
            to: {opacity: 1, transform: 'translateY(0)'},
        },
    },
    dots: {
        display: 'flex',
        gap: 0.4,
        '& span': {
            width: 5,
            height: 5,
            borderRadius: '50%',
            bgcolor: theme.palette.primary.main,
            animation: 'dotPulse 1.4s infinite ease-in-out',
        },
        '& span:nth-of-type(1)': {animationDelay: '0s'},
        '& span:nth-of-type(2)': {animationDelay: '0.16s'},
        '& span:nth-of-type(3)': {animationDelay: '0.32s'},
        '@keyframes dotPulse': {
            '0%, 80%, 100%': {opacity: 0.3, transform: 'scale(0.8)'},
            '40%': {opacity: 1, transform: 'scale(1)'},
        },
    },
    text: {
        fontSize: '0.78rem',
        color: theme.palette.neutral[500],
        fontWeight: 500,
    },
};